export const arr = [
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "中断開始時間",
    cols: "0",
    value: "0,0",
    init: "",
    rule: ",6,,,,,,,,,,,,,,,,,,,true,,,,,,,,",
  },

  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "中断終了時間",
    cols: "0",
    value: "0,0",
    init: "",
    rule: ",6,,,,,,,,,,,,,,,,,,,true,,,,,,,,",
  },
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "中断理由",
    cols: "0",
    value: "0,0",
    init: "",
    rule: ",0,required,,,,,,,,,,,,,,,,,,,,,,,,,,",
  },
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "中断時間",
    cols: "0",
    value: "終了時刻,開始時刻",
    init: "",
    rule: ",0,required,required,dateSub,,,,,,,,,,,,,,,,,,,,,,,,",
  },
];

export default arr;
